import { Col, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { TextVisitCase } from "types/textVisit";
import FileUploadPrivate from "components/form/FileUploadPrivate";
import { updatePatientID } from "api/textVisit";
interface IDUpdateDialogProps {
    open: boolean;
    caseData: TextVisitCase;
    onCancel: () => void;
    onUpdated: () => void;
}

export default function IDUpdateDialog(props: IDUpdateDialogProps) {
    const { open } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [idFrontUrl, setIdFrontUrl] = useState('');
    const [idBackUrl, setIdBackUrl] = useState('');

    const handleSave = async () => {
        if (!props.caseData.prospect.id) return;
        setIsSubmitting(true)
        try {
            await updatePatientID(props.caseData.prospect.id, {
                idFrontUrl: idFrontUrl === props.caseData.patientIdFrontUrl ? undefined : idFrontUrl,
                idBackUrl: idBackUrl === props.caseData.patientIdBackUrl ? undefined : idBackUrl,
            })
            props.onUpdated()
            props.onCancel()
            setIsSubmitting(false)
        } catch (error) {
            console.error(error)
            setIsSubmitting(false)
        }
    }


const renderContent = () => {
    return <div>
        <Row gutter={16}>
            <Col xs={24} md={12}>
                <FileUploadPrivate
                    value={idFrontUrl}
                    notNeedSign
                    onChange={setIdFrontUrl}
                    title="Front of your ID"
                    tips="PNG, JPG, GIF up to 10MB"
                    accept="image/*"
                    uploadType="PROSPECT_IDENTITY"
                />
            </Col>
            <Col xs={24} md={12}>
                <FileUploadPrivate
                    value={idBackUrl}
                    notNeedSign
                    onChange={setIdBackUrl}
                    title="Back of your ID"
                    tips="PNG, JPG, GIF up to 10MB"
                    accept="image/*"
                    uploadType="PROSPECT_IDENTITY"
                />
            </Col>
        </Row>
    </div>
}

function initEditID() {
    setIdFrontUrl(props.caseData.patientIdFrontUrl || '');
    setIdBackUrl(props.caseData.patientIdBackUrl || '');
}

useEffect(() => {
    if (open) {
        initEditID()
        return
    }
}, [open])

return (
    <Modal
        title="Edit ID"
        destroyOnClose
        open={props.open}
        onCancel={props.onCancel}
        width={900}
        okText="Save"
        onOk={handleSave}
        confirmLoading={isSubmitting}
    >
        <div>
            {renderContent()}
        </div>
    </Modal>
)
}
